module.exports = __webpack_public_path__ + "img/09-french.db78cc16.svg";